<small *ngIf="isControlHasError(form, controlName, validation)" class="form-text text-danger">
  {{ errorMessage }}
</small>
